/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { select, put } from 'redux-saga/effects';

import updateMobileHeaderState from 'src/redux/global/actions/update-mobile-header-state';
import { getIsMobileHeaderActive } from 'src/selectors/global-selectors';

import toggleNavigation from '../actions/toggle-navigation';

// @ts-ignore
export default function* updateNavigationStateSaga(action) {
  const isMobileHeaderActive: boolean = yield select(getIsMobileHeaderActive);
  const isOpen = action.payload !== undefined && action.payload;
  if (isMobileHeaderActive && !isOpen) {
    yield put(updateMobileHeaderState('none'));
  } else {
    yield put(toggleNavigation(action.payload) as any);
  }
}
